import React, { useEffect, useState } from "react";
import "../../assets/css/inspection-overview/sites.css";

import { Dialog } from "primereact/dialog";

function readStoredUser(): {
  email?: string;
  firstName?: string;
  lastName?: string;
  type?: string;
} | null {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    const u = JSON.parse(raw) as unknown;
    return u && typeof u === "object" ? (u as { email?: string; firstName?: string; lastName?: string; type?: string }) : null;
  } catch {
    return null;
  }
}

const User: React.FC<any> = (props: {displayUser:boolean,setDisplayUser:any}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const closeHandler = () => {
    setIsModalVisible(false);
    props.setDisplayUser(false);
  };
  useEffect(() => {
    setIsModalVisible(props.displayUser);
  }, [props.displayUser]);
  const layerStyle = { minHeight:"200px", padding:"10px 16px", minWidth:"360px", whiteSpace:"nowrap"}
  const minWidth = {minWidth:"110px"};
  const userRow = readStoredUser();

  return (
    <>
      <Dialog
        header={"User"}
        visible={isModalVisible}
        style={{ minWidth: "30vw" }}
        onHide={closeHandler}
        draggable={false}
        resizable={false}
      >
        <div className="col-md-6 pt-3" style={layerStyle}>
          <label className="form-label pb-3 flex"> <div style={minWidth}>Logged In As </div><div>{`: ${userRow?.email ?? "—"}`}</div></label>
          <label className="form-label pb-3 flex"> <div style={minWidth}>First Name </div><div>{`: ${userRow?.firstName ?? "—"}`}</div></label>
          <label className="form-label pb-3 flex"> <div style={minWidth}>Last Name </div><div>{`: ${userRow?.lastName ?? "—"}`}</div></label>
          <label className="form-label pb-3 flex"> <div style={minWidth}>User Permission </div><div>{`: ${userRow?.type ?? "—"}`}</div></label>
        </div>
      </Dialog>
    </>
  );
};

export default User;
